var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "accordion" },
    [
      !_vm.hideTopActions
        ? _c(
            "KGrid",
            {
              style: {
                backgroundColor: _vm.$themePalette.grey.v_200,
              },
            },
            [
              _c(
                "KGridItem",
                {
                  staticClass: "header-actions",
                  attrs: {
                    layout4: { span: 2 },
                    layout8: { span: 4 },
                    layout12: { span: 6 },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "header-left-actions" },
                    [_vm._t("left-actions")],
                    2
                  ),
                ]
              ),
              _c(
                "KGridItem",
                {
                  staticClass: "header-actions",
                  attrs: {
                    layout4: { span: 2 },
                    layout8: { span: 4 },
                    layout12: { span: 6 },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "header-right-actions" },
                    [_vm._t("right-actions")],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition-group",
        { staticClass: "wrapper", attrs: { tag: "div", name: "list" } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }